{
  "seo": {
    "title": "Family Stories & Reviews",
    "description": "Read testimonials and short case studies from parents and schools using CuriPop to support curious kids.",
    "keywords": "parent testimonials, kids app reviews, school quotes, learning outcomes"
  },
  "hero": {
    "title": "Real Families. Real Outcomes.",
    "subtitle": "Parent testimonials, teacher feedback, and simple before/after outcomes from homes and classrooms."
  },
  "sections": {
    "testimonials": {
      "title": "What families are saying"
    },
    "caseStudies": {
      "title": "Short case studies",
      "before": "Before",
      "after": "After"
    }
  },
  "testimonials": {
    "items": [
      {
        "quote": "My son moved from short one-word answers to reading full explanations out loud in two weeks. He asks better questions now.",
        "name": "Jasmine R.",
        "role": "Parent of a 7-year-old"
      },
      {
        "quote": "Both of my kids use one family account, and the reading-level personalization keeps each one engaged at their own pace.",
        "name": "Marcus L.",
        "role": "Parent of 2 learners"
      },
      {
        "quote": "We use CuriPop during morning warm-up. Students stay focused, and the explanations are age-appropriate and accurate.",
        "name": "Alicia W.",
        "role": "Elementary teacher"
      }
    ]
  },
  "caseStudies": {
    "items": [
      {
        "title": "Bedtime curiosity routine",
        "before": "Parents spent 20+ minutes searching and filtering answers online.",
        "after": "Families opened CuriPop and got trusted, child-ready answers in under 2 minutes.",
        "metric": "Time-to-answer reduced by 80%"
      },
      {
        "title": "Sibling learning consistency",
        "before": "One child got bored while the other felt overwhelmed by reading complexity.",
        "after": "Reading-level adjustments gave both children confident independent use.",
        "metric": "Daily return sessions increased 2.1x"
      }
    ]
  },
  "cta": {
    "title": "Ready to try it with your family?",
    "subtitle": "Start free today and see how quickly curiosity turns into confident learning.",
    "primary": "Start Free",
    "secondary": "Why Subscribe"
  }
}
